import React from 'react';

const isEmpty = value => value === undefined || value === null || value === '';

export function saveToSessionStorage (state) {
  try 
  {
      const serializedState = JSON.stringify (state);
      sessionStorage.setItem ('state', serializedState)
  
  }    
  catch (e) {
      console.log (e)
  }
}
  
export function loadFromSessionStorage () {
  try 
  {
      const serializedState = sessionStorage.getItem('state');
      if ( serializedState == null ) return undefined;
          return JSON.parse (serializedState)            
      }
  catch (e) {
      console.log (e);
      return undefined
  }
}

export function email(value) {
    // Let's not start a debate on email regex. This is just for an example app!
    if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      return 'Invalid email address';
    }
  }
  
  export function required(value) {
    if (isEmpty(value)) {
      return 'Required';
    }
  }
  
  export function minLength(min) {
    return value => {
      if (!isEmpty(value) && value.length < min) {
        return `Must be at least ${min} characters`;
      }
    };
  }
  
  export function maxLength(max) {
    return value => {
      if (!isEmpty(value) && value.length > max) {
        return `Must be no more than ${max} characters`;
      }
    };
  }
  
  export function splitLines(text, textFont, maxTextWidth, lineHeight, x) {
    // Split text into words by spaces
    let words = text.split(' ');
    let lastWord = words[words.length - 1];
    let lineWidth = 0;
    let thisLine = '';
    let allLines = [];

    // For every element in the array of words
    for (let i = 0; i < words.length; i++) {
        let word = words[i];
        // Add current word to current line
        thisLine = thisLine.concat(word + ' ');
        // Get width of the entire current line
        lineWidth = getTextWidth(thisLine, textFont);
        // If word is not the last element in the array
        if (word !== lastWord) {
            // Find out what the next upcoming word is
            let nextWord = words[i + 1];
            // Check if the current line + the next word would go over width limit
            if (lineWidth + getTextWidth(nextWord, textFont) >= maxTextWidth) {
                // If so, add the current line to the allLines array
                // without adding the next word
                addToAllLines(thisLine);
            } 
            // '~' indicates inserting a blank line, if required
            else if (word === '~') {
                addToAllLines(' ');
            }
            // If the next word is a line break, end line now
            else if (nextWord === '~') {
                addToAllLines(thisLine);
            }
        }
        // If this IS the last word in the array
        else {
            // Add this entire line to the array and return allLines
            addToAllLines(thisLine);
            let itms= [];
            allLines.map((line, index) =>
              (
                 itms.push(<tspan key ={index}> {line.trim()}</tspan>)
            ));
            return itms;
        }
    }

    // Function that adds text to the array of all lines
    function addToAllLines(text1) 
    {
       allLines.push(text1);
       thisLine = '';
       lineWidth = 0;
    }    

}

export function sectorDetails(position) {
  
  position = parseInt(position);
  
  let positionDefinitions = [
    {position: 1, definition: "Rents at Peak", color: "#00a657"},
    {position: 2, definition: "Rent Decline Accelerating", color: "#007554"},
    {position: 3, definition: "Rent Decline Slowing", color: "#0087a7"},
    {position: 4, definition: "Rents at Trough", color: "#75116a"},
    {position: 5, definition: "Rent Growth Accelerating", color: "#bc006f"},
    {position: 6, definition: "Rent Growth Slowing", color: "#cb630b"}
  ];

  let found = positionDefinitions.filter(function (item) { return item.position === position; });
  let def =(found[0] ? found[0].definition : position);
  let color = (found[0] ? found[0].color : '#D2B600');
  return {sectorText:def, sectorColor:color};
}

function getTextWidth(text, textFont) {

  let canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  let context = canvas.getContext("2d");
  context.font =textFont;
  let metrics = context.measureText(text);
  return metrics.width;
}


export function getParams(location,param)  {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(param) || ''
 
}

export function setParams(query = "", param) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(param, query.trim());
  return searchParams.toString();
}

export function appendParams(query = "", param) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.append(param, query.trim());
  return searchParams.toString();
}

export function deleteParams(param) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  return searchParams.toString();
}

export function metersConversion(param, unit) {
  if (Number.isNaN(parseInt(param))) {
    return 0;
  }
  return (param * unit);
}